import { rocks } from "./Rocks";

export interface OptionChoice {
    value: string;
    label: string;
    weight: number;
}

export interface Option {
    id: string;
    label: string;
    options: OptionChoice[];
}

export interface Factor {
    categoryId: string;
    option: OptionChoice;
}

export const maxWeightsSum = (options: Option[]) => {
    return options.reduce((sum, option) => sum + option.options[option.options.length - 1].weight, 0);
}

export const sumFactorWeights = (factors: Factor[]): number => {
    return factors.reduce((sum, factor) => sum + factor.option.weight, 0);
}

export const weightToBucket = (weight: number, maxWeight: number): number => {
    const numBuckets = rocks.length;
    const bucketSize = (maxWeight) / numBuckets;
    return Math.round(weight / bucketSize)
}